var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnstackMarkLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.1554 27.9857L46.7206 29.6996C48.3368 30.4761 48.4351 31.9518 46.9392 32.9787L26.7198 46.8582C25.9719 47.3717 24.9859 47.6283 24 47.6283C23.014 47.6283 22.0281 47.3717 21.2801 46.8582L1.06072 32.9787C-0.435203 31.9518 -0.336736 30.4761 1.27931 29.6996L4.84254 27.9857L20.2789 35.9335C21.3018 36.4602 22.6234 36.7501 24 36.7501C25.3766 36.7501 26.6982 36.4602 27.721 35.9335L43.1554 27.9857Z",
    fill: "#4040D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9274 16.7316L46.656 19.0906C48.3078 19.7708 48.3524 21.0002 46.7549 21.8226L26.9042 32.0424C26.1056 32.4535 25.0529 32.659 24.0001 32.659C22.9474 32.659 21.8946 32.4535 21.096 32.0424L1.24527 21.8226C-0.352009 21.0002 -0.307587 19.7708 1.34422 19.0906L7.07032 16.7316L20.3647 21.2942C21.3599 21.6357 22.6509 21.8238 23.9999 21.8238C25.3491 21.8238 26.6401 21.6357 27.6352 21.2942L40.9274 16.7316Z",
    fill: "#4040D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0003 3C25.1284 3 26.2562 3.11748 27.112 3.35245L46.5478 8.6892C48.2591 9.15914 48.2819 10.0164 46.598 10.5943L27.0616 17.2996C26.2197 17.5885 25.1101 17.7329 24.0003 17.7329C22.8906 17.7329 21.7808 17.5885 20.939 17.2996L1.40266 10.5943C-0.281057 10.0164 -0.258445 9.15914 1.45286 8.6892L20.8887 3.35245C21.7444 3.11748 22.8724 3 24.0003 3Z",
    fill: "#4040D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnstackMarkLogo);
export default __webpack_public_path__ + "static/media/unstack-mark-logo.5c93f9a4f40ed35cf03b485d6731f203.svg";
export { ForwardRef as ReactComponent };